// Distância em km com vírgula decimal (500 m vira "0,5 km").
export const formatKm = (meters: number) =>
  `${(meters / 1000).toLocaleString('pt-BR')} km`;
